'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _plugin = require('../../plugin');
var _plugin2 = _interopRequireDefault(_plugin);
var _errorHelper = require('../../helpers/errorHelper');
var _constants = require('../../constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ConnectionManager = function (_Plugin) {
  _inherits(ConnectionManager, _Plugin);
  function ConnectionManager(entity) {
    _classCallCheck(this, ConnectionManager);
    var _this = _possibleConstructorReturn(this, (ConnectionManager.__proto__ || Object.getPrototypeOf(ConnectionManager)).call(this, entity));
    _this.cancelReconnect = function (error) {
      if ((0, _errorHelper.isUnauthorizedUserError)(error)) {
        _this.entity.stopReconnection();
        _this.entity.disconnect();
      }
    };
    _this.increaseBackoff = function () {
      _this.entity.setReconnectionDelay(Math.min(ConnectionManager.maxDelay, _this.entity.getReconnectionDelay() * 2));
    };
    _this.resetBackoff = function () {
      _this.entity.setReconnectionDelay(ConnectionManager.initialDelay);
    };
    _this.entity.on(_constants.Events.XMPP_ERROR, _this.cancelReconnect);
    _this.entity.on(_constants.Events.ONLINE, _this.resetBackoff);
    _this.entity.onReconnect(_constants.Events.RECONNECTING, _this.increaseBackoff);
    return _this;
  }
  return ConnectionManager;
}(_plugin2.default);
ConnectionManager.pluginName = 'connectionManager';
ConnectionManager.maxDelay = 60000;
ConnectionManager.initialDelay = 1000;
exports.default = ConnectionManager;